module.exports = __webpack_public_path__ + "img/Sycamoremore.dcd428a7.png";